var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 30 15",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002a8f",
    d: "M0 0h30v15H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h27v3H9v3h21v3H3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb1515",
    d: "M12.99 7.5 0 15V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33 5 2.861 9.523l3.847-2.796H1.952L5.8 9.523z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/cu.a0c225cf777989b6c243e1704c6b1a81.svg";
export { ForwardRef as ReactComponent };